import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { AlertTriangle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Stars } from "@/components/Feedback";
import { api, errMsg } from "@/lib/api";

const Alert = ({ a, onDone }) => {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const done = async () => {
    if (note.trim().length < 2) return toast.error("Add a short follow-up note");
    setBusy(true);
    try { await api.put(`/feedback/${a.id}/follow-up`, { note }); toast.success("Marked as followed up"); onDone(a.id); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-rose-500/20 bg-slate-950/50 p-4 space-y-3" data-testid={`low-rating-${a.id}`}>
      <div className="flex flex-wrap items-center gap-3">
        <Stars value={a.rating} size="h-4 w-4" />
        <span className="text-sm"><span className="text-slate-200">{a.client_name}</span><span className="text-slate-500"> · </span><Link to={`/studies/${a.study_id}`} className="text-slate-300 hover:text-emerald-400">{a.study_name}</Link></span>
        <span className="text-xs text-slate-500 ml-auto">{a.low_alert_at?.slice(0, 10)}</span>
      </div>
      {a.comment && <p className="text-sm text-slate-400">“{a.comment}”</p>}
      <div className="flex flex-wrap gap-2">
        <Input data-testid={`low-rating-note-${a.id}`} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Follow-up note, e.g. called client, offered a revision" className="flex-1 min-w-[220px] h-9 bg-slate-950/60 border-slate-700" />
        <Button data-testid={`low-rating-done-${a.id}`} size="sm" disabled={busy} onClick={done} className="rounded-full bg-rose-500 text-white hover:bg-rose-400">{busy && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}Mark followed up</Button>
      </div>
    </div>
  );
};

export const LowRatingAlerts = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/feedback/low-ratings").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="rounded-xl border border-rose-500/40 bg-rose-500/5 p-6 mb-8 space-y-4" data-testid="low-rating-alerts">
      <h2 className="flex items-center gap-2 font-display text-lg font-semibold text-rose-300"><AlertTriangle className="h-5 w-5" />Low ratings to follow up <span className="num text-sm px-2 rounded-full bg-rose-500/20">{items.length}</span></h2>
      {items.map((a) => <Alert key={a.id} a={a} onDone={(id) => setItems((l) => l.filter((x) => x.id !== id))} />)}
    </section>
  );
};
